import React, { useState, useEffect, useContext } from "react";
import { SidebarData } from "./SideBarData";
import SubMenu from "./submenu";
import "./Sidebar.css";
import * as IoIcons from "react-icons/io";
import Context from "../../context/Context";

export default function Sidebar() {
  const [mouseOver, setMouseOver] = useState(false);
  const {
    displayMenu,
    setDisplayMenu,
    displayIcon,
  } = useContext(Context);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  });

  const handleResize = () => window.innerWidth < 767 ? setDisplayMenu("none") : setDisplayMenu("");

  const changeDisplay = () => {
    const display = !displayMenu ? "none" : "";

    setDisplayMenu(display);
  };

  return (
    <>
      <nav
        className={`SideBarNav ${displayMenu == 'none' ? 'closed' : ""}`}
        onMouseOver={() => window.innerWidth < 767 ? "" : setMouseOver(true)}
        onMouseOut={() => window.innerWidth < 767 ? "" : setMouseOver(false)}
      >
        <div className="SideBarWrap">
          {window.innerWidth < 767 && (
            <div>
              <IoIcons.IoMdMenu
                size={30}
                className={`icon_menu ${displayMenu == 'none' ? "" : "icon_menu_over"} `}
                style={{ display: displayIcon }}
                onClick={changeDisplay}
              />
            </div>
          )}
          {SidebarData.map((item, index) => {
            return (
              <SubMenu
                item={item}
                key={`${item.title}-${index}`}
                mouseOver={mouseOver}
              />
            );
          })}
        </div>
      </nav>
    </>
  );
}
